export default __webpack_public_path__ + "static/media/Mystic's Helm of the Bloody Stone.0b521cb6.jpg";